import { Button } from '@eliadmin/core/src/components/ui/button';
import {
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from '@eliadmin/core/src/components/ui/dialog';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const FavoriteProductsDeleteAllDialog = () => {
  const { t } = useTranslations();

  const deleteWishlist = () => {
    localStorage.setItem('favoriteProducts', '[]');
    window.dispatchEvent(new Event('storage'));
  };

  return (
    <>
      <DialogContent className="rounded-none">
        <DialogHeader className="text-start text-2xl font-semibold sm:text-3xl">
          {t('text1383').toUpperCase()}
        </DialogHeader>
        <DialogFooter className="flex flex-row gap-4">
          <DialogClose asChild>
            <Button variant="outline" onClick={() => deleteWishlist()}>
              {t('text1384').toUpperCase()}
            </Button>
          </DialogClose>
          <DialogClose asChild>
            <Button>{t('text1385').toUpperCase()}</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </>
  );
};

FavoriteProductsDeleteAllDialog.id = 'FAVORITE_PRODUCTS_DELETE_ALL_DIALOG_ID';
